<template>
  <h1 class="title has-text-centered is-spaced">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <go-to-dashboard-button />

    {{ productsQty }} Produtos&nbsp;&nbsp;

    <button
      class="button"
      @click="$emit('get-products')"
      :style="addMarginRefreshButton ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["permissions", "productsQty"],

  mixins: [common, responsive],

  data() {
    return {
      isLoading: false
    };
  },

  components: {
    goToDashboardButton
  },

  methods: {},

  computed: {
    addMarginUploadImagesButton() {
      return this.windowWidth < 612;
    },
    addMarginReportButton() {
      return this.windowWidth < 485;
    },
    addMarginAddProductButton() {
      return this.windowWidth < 428;
    },
    addMarginRefreshButton() {
      return this.windowWidth < 370;
    }
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
